import React, { useEffect, useState } from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
const AppointmentTable = (props) => {
    const [displayData, setDisplayData] = useState([]);
    const [appRowsPerPage, setAppRowsPerPage] = useState(10);
    const [appPage, setAppPage] = useState(0);
    const [userId, setUserId] = useState('')

    const handleChangeAppPage = (event, newPage) => {
        setAppPage(newPage);
    };

    const handleChangeAppRowsPerPage = (event) => {
        setAppRowsPerPage(parseInt(event.target.value, 10));
        setAppPage(0);
    };

    useEffect(() => {
        if (props.selectedUserId === userId){
            props.getAppointmentDetail(props.selectedUserId, appPage, appRowsPerPage);
        } else {
            setUserId(props.selectedUserId)
        }
    }, [appPage, appRowsPerPage])

    useEffect(() => {
        setDisplayData(props.reportData);
    }, [props]);

    return (
        <>
            <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">S.No.</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">Patient Name</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM">Doctor Name</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Date</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Time</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Payment</span>
                                </TableCell>
                                <TableCell className="tableHead">
                                    <span className="elslistTxtM ">Amount (Cents)</span>
                                </TableCell> 
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayData.map((each, index) => (
                                <TableRow>
                                    <TableCell className="capitalTxt">{index+1}</TableCell>
                                    <TableCell className="capitalTxt">{each.patientData.name}</TableCell>
                                    <TableCell className="capitalTxt">
                                        {`${each.doctorData.name}`}
                                        <span className="smallText">
                                            {`( ${each.doctorData.department} , ${each.doctorData.speciality} )`}
                                        </span>
                                    </TableCell>
                                    <TableCell className="capitalTxt">
                                        {new Date(each.startTime).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell>
                                        {new Date(each.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}{" - "}
                                        {new Date(each.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                    </TableCell>
                                    {each.doctorData.consultationFee ? <TableCell className="capitalTxt">{each.paymentStatus}</TableCell> : <TableCell className="capitalTxt">Free</TableCell>}
                                    <TableCell className="capitalTxt">{each.doctorData.cents}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <div className="flexCol justifyEnd">
                <TablePagination
                    component="div"
                    count={props.count}
                    page={appPage}
                    onPageChange={handleChangeAppPage}
                    rowsPerPage={appRowsPerPage}
                    onRowsPerPageChange={handleChangeAppRowsPerPage}
                />
            </div>
        </>
    );
};
export default AppointmentTable;
